module.exports = __webpack_public_path__ + "static/media/wistia.631e5bd0.svg";